import React from 'react';
import { motion } from 'framer-motion';
export function AuthorSection() {
  return <section className="w-full bg-crema py-16 md:py-20 px-6" data-id="element-12">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      margin: '-100px'
    }} transition={{
      duration: 0.8
    }} className="max-w-[900px] mx-auto grid grid-cols-1 md:grid-cols-[35%_65%] gap-10 items-center" data-id="element-13">
        <div className="flex justify-center md:justify-end" data-id="element-14">
          <img src="https://cdn.magicpatterns.com/uploads/k45118mSxkyGzbGhgJMSjr/Roderic_Busto.png" alt="Roderic Guillen" className="w-64 md:w-72 rounded-xl object-cover border-[3px] border-gold shadow-md" data-id="element-15" />
        </div>

        <div className="flex flex-col text-center md:text-left" data-id="element-16">
          <span className="font-sans font-bold text-[11px] text-gold uppercase" data-id="element-17">
            SOBRE EL AUTOR
          </span>

          <h2 className="text-2xl font-serif font-bold text-navy mt-2" data-id="element-18">
            Roderic Guillen
          </h2>

          <p className="text-sm font-sans italic text-[#888888]" data-id="element-19">
            Ingeniero Civil &middot; Autor &middot; GoDeskCore &middot; PROSPERA
          </p>

          <p className="text-[15px] font-sans text-[#4A4A4A] leading-[1.85] mt-3" data-id="element-20">
            Ingeniero Civil. Mayor de 40. Alguien que estudió, analizó y
            encontró la manera más clara de explicar la IA para quienes no
            venimos del mundo tecnológico. Escribí el libro que yo mismo
            necesitaba cuando sentí que el mundo me adelantaba por la izquierda.
            Hoy entiendo la IA con claridad. Y vine a mostrarte el camino. Para
            que tú llegues más rápido. Con menos cansancio. Y con más fuerzas.
          </p>

          <div className="flex items-center gap-5 mt-4" data-id="element-21">
            <a href="https://www.facebook.com/godeskcore" target="_blank" rel="noopener noreferrer" className="text-gold hover:text-burnt transition-colors" aria-label="Facebook" data-id="element-22">
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="currentColor" data-id="element-23">
                <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" data-id="element-24" />
              </svg>
            </a>
            <a href="https://www.instagram.com/godeskcore" target="_blank" rel="noopener noreferrer" className="text-gold hover:text-burnt transition-colors" aria-label="Instagram" data-id="element-25">
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="currentColor" data-id="element-26">
                <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z" data-id="element-27" />
              </svg>
            </a>
            <a href="mailto:godeskcore@gmail.com" className="text-gold hover:text-burnt transition-colors" aria-label="Email" data-id="element-28">
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-29">
                <rect width="20" height="16" x="2" y="4" rx="2" data-id="element-30" />
                <path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7" data-id="element-31" />
              </svg>
            </a>
          </div>
        </div>
      </motion.div>
    </section>;
}